<template>
    <div>
      <PRSummary/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import PRSummary from '@/components/EditPRSummary.vue'
  
  export default {
    name: 'pr-summary',
    components: {
      PRSummary
    }
  }
  </script>
  